import { useMutation, useQueryClient } from '@tanstack/react-query';
import { resetUserMfa } from '../services/users';
import { userKeys } from './useUsersQuery';
import { handleUserMutationError } from '../services/userErrorHandler';
import type { AdminUser } from '../types/users.types';

export const useResetMfaMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<AdminUser, Error, string>({
        mutationFn: (id) => resetUserMfa(id),
        onSuccess: (_, id) => {
            queryClient.invalidateQueries({ queryKey: userKeys.detail(id) });
        },
        onError: (error) => handleUserMutationError(error),
    });
};
